import { useDisclosure } from "@mantine/hooks";
import { t } from "ttag";

import { ConfirmModal } from "metabase/common/components/ConfirmModal";
import { EditBar } from "metabase/common/components/EditBar";
import {
  PermissionsConfirm,
  type PermissionsGraphDiff,
  isEmbeddingHubPermissions,
} from "metabase/permissions";
import { Button } from "metabase/ui";

import S from "./PermissionsEditBar.module.css";

interface PermissionsEditBarProps {
  diff?: PermissionsGraphDiff;
  isDirty: boolean;
  onCancel: () => void;
  onSave?: () => void;
}

export function PermissionsEditBar({
  diff,
  isDirty,
  onCancel,
  onSave,
}: PermissionsEditBarProps) {
  const [modelOpened, { open: openModal, close: closeModal }] = useDisclosure();
  const isEmbeddingHub = isEmbeddingHubPermissions();
  const saveButton = (
    <Button
      key="save"
      onClick={openModal}
      disabled={!isDirty}
      variant={isEmbeddingHub ? "filled" : "on-dark-primary"}
    >{t`Save changes`}</Button>
  );

  const cancelButton = (
    <Button
      variant={isEmbeddingHub ? "default" : "on-dark-secondary"}
      onClick={onCancel}
      key="cancel"
    >
      {t`Cancel`}
    </Button>
  );

  return (
    <>
      <EditBar
        location={isEmbeddingHub ? "embedding-hub" : "admin"}
        className={isEmbeddingHub ? S.hubEditBar : undefined}
        title={t`You've made changes to permissions.`}
        buttons={[cancelButton, saveButton]}
      />
      <ConfirmModal
        title={t`Save permissions?`}
        opened={modelOpened}
        content={diff ? <PermissionsConfirm diff={diff} /> : null}
        onConfirm={() => {
          onSave?.();
          closeModal();
        }}
        onClose={closeModal}
      />
    </>
  );
}
